import { BehaviorSubject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'

class UpdateBloc {
    updateRepository = new UpdateRepository()
    
    updateChannel = new BehaviorSubject({
        status: apiResponse.INITIAL,
        data: []
    })

    detailChannel = new BehaviorSubject({
        status: apiResponse.INITIAL,
        data: []
    })

    async fetchUpdate(data) {
        this.updateChannel.next({
            status: apiResponse.LOADING,
            data: []
        })

        try {
            const response = await this.updateRepository.fetchUpdate(data)
            this.updateChannel.next({
                status: apiResponse.COMPLETED,
                data: response
            })
        } catch (error) {
            this.updateChannel.next({
                status: apiResponse.ERROR,
                data: error
            })
        }
    }

    async fetchDetail(data) {
        this.detailChannel.next({
            status: apiResponse.LOADING,
            data: []
        })

        try {
            const response = await this.updateRepository.fetchDetail(data)
            this.detailChannel.next({
                status: apiResponse.COMPLETED,
                data: response
            })
        } catch (error) {
            this.detailChannel.next({
                status: apiResponse.ERROR,
                data: error
            })
        }
    }
}

export default UpdateBloc
